import BaseModal from 'react-bootstrap/Modal'
import React, { Component } from 'react'
import Icons from './Icons'
import Images from './Images'

export class Modal extends Component {
  handleClose = () => {
    const { setShowCredits } = this.props
    setShowCredits(false)
  }

  render() {
    const { showCredits } = this.props
    return (
      <BaseModal show={showCredits} onHide={this.handleClose}>
        <BaseModal.Header closeButton>
          <BaseModal.Title>Credits</BaseModal.Title>
        </BaseModal.Header>
        <BaseModal.Body>
          <Icons />
          <Images />
        </BaseModal.Body>
      </BaseModal>
    )
  }
}

export default Modal
